export enum MailType {
  Magiclink = 'magiclink',
  Contract = 'contract',
  Welcome = 'welcome',
  Promotion = 'promotion',
}
